"use strict";
window.theme = window.theme || {}
theme.quickMedalRegisterDrawer = function() {

    function quickMedalRegisterDrawer() {

        this.btn = {
            product_page: document.querySelectorAll('.quick-medal-register-drawer .product-medal-form button'),
            close: document.querySelectorAll('.quick-medal-register-drawer .quick-medal-register-drawer__close'),
            overlay: document.querySelectorAll('.quick-medal-register-drawer .quick-medal-register-drawer__overlay'),
            country_label: document.querySelector('.quick-medal-register-drawer label[for="location"]'),
            product_handle_close: document.querySelectorAll('.quick-medal-register-drawer .product_medal_close'),
            register: document.querySelector('.quick-medal-register-drawer-input-form .contact-form-submit'),
            info: document.querySelector('.quick-medal-register-drawer-input-form .decanter-text-info'),
            info_close: document.querySelector('.quick-medal-register-drawer-input-form .decanter-registration-close')            
        }
        this.container = {
            quick_drawer: document.querySelector('.quick-medal-register-drawer'),
            country_list: document.querySelector('.quick-medal-register-drawer [name="contact[country]"]'),
            confirmation: document.querySelector('.quick-medal-register-drawer .form-submit-status'),
            decanter_handle: document.querySelectorAll('.quick-medal-register-drawer .medal-form-decanter-product'),
            info: document.querySelector('.quick-medal-register-drawer .decanter-registration-info'),
            decanter_form: document.querySelector('.quick-medal-register-drawer-header.container-registration-form'),
            decanter_submit_success: document.querySelector('.quick-medal-register-drawer-header.successfull-post'),
            success_form: document.querySelector('.quick-medal-register-drawer__container'),
            account_page: document.querySelector('section.account.page')            
        }
        this.input = {
            decanter_code: document.querySelector('.quick-medal-register-drawer [name="contact[decanternumber]"]'),
            address: document.querySelector('.quick-medal-register-drawer [name="contact[address]"]'),
            city: document.querySelector('.quick-medal-register-drawer [name="contact[city]"]'),
            postcode: document.querySelector('.quick-medal-register-drawer [name="contact[postcode]"]'),
            country: document.querySelector('.quick-medal-register-drawer [name="contact[country]"]'),
            salutation: document.querySelector('.quick-medal-register-drawer [name="contact[salutation]"]'),
            firstname: document.querySelector('.quick-medal-register-drawer [name="contact[first_name]"]'),
            lastname: document.querySelector('.quick-medal-register-drawer [name="contact[last_name]"]'),
            email: document.querySelector('.quick-medal-register-drawer [name="contact[email]"]'),
            product_handle: document.querySelector('.quick-medal-register-drawer [name="contact[producthandle]"]'),
            customer_id: document.querySelector('.quick-medal-register-drawer [name="contact[customerid]"]')            
        }
        this.label = {
            decanter_code: document.querySelector('.quick-medal-register-drawer [for="register_decanter_no"]'),
            address: document.querySelector('.quick-medal-register-drawer [for="register_address"]'),
            city: document.querySelector('.quick-medal-register-drawer [for="register_city"]'),
            postcode: document.querySelector('.quick-medal-register-drawer [for="register_postcode"]'),
            country: document.querySelector('.quick-medal-register-drawer [for="register_location"]'),
            confirmation_error: document.querySelector('.quick-medal-register-drawer-input-form .notification-error')
        }
        this.api = {
            url: null,
            loadingbar: document.querySelector('.quick-medal-register-drawer .api-loader'),
            spinner: document.querySelector('.quick-medal-register-drawer-input-form button > .spinner')
        }

        this.load();

    }
    const myCollectionActiveScreen = () => {
        const account_container = document.querySelectorAll('.account__content_right > div');
        const account_navItems = document.querySelectorAll('.account__navigation_left li');
        account_container.forEach(el => {                        
            if(el.classList.contains('account__collection')) {
                el.classList.remove('hide_nav_area');
                account_navItems.forEach(item => {
                    item.classList.remove('active_nav');
                })
                document.querySelectorAll('.nav-account-collection').forEach(el => {
                    el.parentElement.classList.add('active_nav');
                })
            } else {
                el.classList.add('hide_nav_area');
            }                    
        })
    }
    quickMedalRegisterDrawer.prototype.load = function() {
        var _ = this; 
        _.btn.product_page.forEach(element => {
            element.addEventListener('click', () => {
                _.opendrawer('',false,'');
            })
        })
        _.btn.close.forEach(element => {
            element.addEventListener('click', () => {
                _.closedrawer();
            })
        })
        _.btn.overlay.forEach(element => {
            element.addEventListener('click', () => {
                _.closedrawer();
            })
        })
        if(_.container.country_list && _.container.country_list.length>0) {
            _.repopulatecountry();
        }
        if(_.getregistersuccess('quickmedalregisterdrawersuccess') === 'error' && _.getdrawerstatus('quickmedalregisterdrawer') === 'close') {
                _.container.decanter_submit_success.classList.add('d-none');
                _.container.decanter_form.classList.remove('d-none');
                _.container.success_form.classList.remove('success');
            _.closedrawer();
        }
        if(_.getregistersuccess('quickmedalregisterdrawersuccess') === 'success' && _.getdrawerstatus('quickmedalregisterdrawer') === 'open') {
            document.addEventListener("DOMContentLoaded", () => {
                _.opendrawer('', false,'');
                _.container.decanter_form.classList.add('d-none');
                _.container.decanter_submit_success.classList.remove('d-none');      
                _.container.success_form.classList.add('success');     
                if(window.location.pathname.includes('account')) {
                    myCollectionActiveScreen();
                }             
            });              
        }   
        _.btn.product_handle_close.forEach(el => {
            el.addEventListener('click', (event) => {
                event.target.closest('button').parentElement.classList.remove('active');
            }) 
        }) 
       if(_.input.address) {
           _.input.address.addEventListener('focus', (event) => {
           _.label.address.classList.add('focus');
        })
          _.input.address.addEventListener('focusout', (event) => {
                if(event.target.value === '') {
                    _.label.address.classList.remove('focus');
                }           
            })
        }
        if(_.input.city) {
        _.input.city.addEventListener('focus', (event) => {
            _.label.city.classList.add('focus');
        })
        _.input.city.addEventListener('focusout', (event) => {
            if(event.target.value === '') {
                _.label.city.classList.remove('focus');
            }           
        })
        }
        if(_.input.postcode) {
        _.input.postcode.addEventListener('focus', (event) => {
            _.label.postcode.classList.add('focus');
        })
        _.input.postcode.addEventListener('focusout', (event) => {
            if(event.target.value === '') {
                _.label.postcode.classList.remove('focus');
            }           
        })
        }
        if(_.input.country) {
        _.input.country.addEventListener('focus', (event) => {
            if(_.label.country)_.label.country.classList.add('focus');
        })
        _.input.country.addEventListener('focusout', (event) => {
            if(event.target.value === '') {
            if(_.label.country)_.label.country.classList.remove('focus');
            }           
        })
        }
        if(_.input.decanter_code) {
        _.input.decanter_code.addEventListener('focus', (event) => {
            _.label.decanter_code.classList.add('focus');
        })
        _.input.decanter_code.addEventListener('focusout', (event) => {
            if(event.target.value === '') {
                _.label.decanter_code.classList.remove('focus');
            }           
        })
        _.input.decanter_code.addEventListener('change', (event) => {
            if(event.target.value === '') {
                _.label.decanter_code.classList.remove('focus');
            } else {
                _.label.decanter_code.classList.add('focus');
            }         
        })
        }
        if(_.btn.register) {
            _.btn.register.addEventListener('click', event => {
                const progressElement = document.getElementById('progress'),
                progressBarElement = document.querySelector('.progress-bar'),
                notificationOperation = document.querySelector(".notification-operation"),
                notificationOperationTwo = document.querySelector(".notification-operation-two");
                if(_.input.decanter_code.value !== '') {
                    notificationOperation.textContent = "DEAR CLIENT, PLEASE TAKE IN CONSIDERATION THAT";
                    notificationOperationTwo.textContent = "THIS OPERATION CAN TAKE UP TO 1 MINUTE.";
                    progressBarElement.classList.add('start');
                    progressElement.classList.add('active');
                    event.preventDefault();
                    _.register();
                }
            })
        }
        if(_.btn.info) {
            _.btn.info.addEventListener('click', event => {
                _.container.info.classList.toggle('active');
            })
        }
        if(_.btn.info_close) {
            _.btn.info_close.addEventListener('click', event => {
                _.container.info.classList.toggle('active');
            })
        }
        _.api.url = this.container.quick_drawer.getAttribute('data-api-url');
        document.addEventListener("DOMContentLoaded", () => {       
            let homepage_slider_decanter = document.querySelectorAll('form.slideshow__registration-form > button');
            if(homepage_slider_decanter.length>0) {
            homepage_slider_decanter.forEach(el => {
                el.addEventListener('click', (event) => {
                    if(event.target.closest('button').previousElementSibling.value !== '') {
                        event.preventDefault();
                        if(event.target.closest('button').getAttribute('data-form') === 'medal-form' && typeof theme.quickMedalDrawer !== 'undefined') {
                            theme.quickMedalDrawer.opendrawer(event.target.closest('button').previousElementSibling.value);
                            theme.quickMedalDrawer.label.decanter_code.classList.add('focus');
                        } 
                        if(event.target.closest('button').getAttribute('data-form') === 'register-form' && typeof theme.quickMedalRegisterDrawer !== 'undefined') {
                            theme.quickMedalRegisterDrawer.opendrawer(event.target.closest('button').previousElementSibling.value);
                            theme.quickMedalRegisterDrawer.label.decanter_code.classList.add('focus');
                        }
                        return false;
                    } else {
                        return true;
                    }
                })  
            }) 
            }
        })
        if(window.location.pathname.includes('account') && _.getuserfirsttimelogin('userfirsttimelogin') !== 'off') {
                let url_string = window.location.search;
                let urlParams = new URLSearchParams(url_string);
                let view = urlParams.has('view');
                if(view) {
                    _.setuserfirsttimelogin('off');
                    _.opendrawer(_.getdecanterfirsttime('firsttimelogindecanter') === 'close' ? '' : _.getdecanterfirsttime('firsttimelogindecanter'));
                    _.label.decanter_code.classList.add('focus');  
                }         
        }          
    }
    quickMedalRegisterDrawer.prototype.opendrawer = function(decanter_number, inputreadonly, product_handle) {
        var _ = this; 
        let scrollPosition = window.pageYOffset;
        _.container.quick_drawer.classList.add('active');
        _.container.quick_drawer.classList.add('visible');
        document.body.style.setProperty('padding-right', '6px');
        document.body.style.setProperty('overflow', 'hidden');   
        document.body.style.setProperty('position', 'fixed');  
        document.body.style.setProperty('top', `-${scrollPosition}px`);  
        document.body.style.setProperty('width', '100%');  

        myCollectionActiveScreen();

        if(decanter_number !=='' &&  _.input.decanter_code) {
            _.input.decanter_code.value = decanter_number;
        }        
        if(inputreadonly && _.input.decanter_code) {
            _.input.decanter_code.setAttribute('readonly','');
        } else {
            if( _.input.decanter_code)_.input.decanter_code.removeAttribute('readonly');
        }
        if(product_handle !== '') {
            _.container.decanter_handle.forEach(el => {
                if(product_handle === el.getAttribute('data-product-handle')) {
                    el.classList.add('active');
                } else {
                    el.classList.remove('active');
                }
            })
        }
        _.setdrawerstatus('open');
        _.setcurrenturl(window.location.pathname);
    }
    quickMedalRegisterDrawer.prototype.closedrawer = function() {
        var _ = this; 
        _.container.quick_drawer.classList.remove('active');
        _.container.quick_drawer.classList.remove('visible');
        document.body.removeAttribute('style');
        _.setdrawerstatus('close');
        if(_.getregistersuccess('quickmedalregisterdrawersuccess') === 'success') {  
            _.setcurrenturl(window.location.pathname);   
            _.setregistersuccess('error');      
            window.location = window.location.pathname; //require refresh the page to remove successfull post param
        } else {
            if(window.location.pathname.includes('account') && _.getcurrenturl('quickmedalregisterdrawerurl').includes('account')) {
                myCollectionActiveScreen();
                _.setcurrenturl('close');      
                _.setregistersuccess('error');          
             }
        }
    }
    quickMedalRegisterDrawer.prototype.repopulatecountry = function() {
        var _ = this;
        if(_.container.country_list.getAttribute('data-location') == null) {
            return false;
        };
        fetch(_.container.country_list.getAttribute('data-location'), {
        method: 'GET'
        })
        .then(response => {
        return response.json();
        })  
        .then(data => { 
            if(data.length>0) {
                data.forEach((country) => {
                let newOption = new Option(country.name, country.name);
                _.container.country_list.add(newOption,undefined);
                })  
                _.container.country_list.selectedIndex = 0;      
               }
        })        
        .catch((error) => {
               console.error('Error:', error);
        });
    }
    quickMedalRegisterDrawer.prototype.setdrawerstatus = function(cvalue) {
        const d = new Date();
        d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000));
        let expires = "expires="+d.toUTCString();
        document.cookie = 'quickmedalregisterdrawer' + "=" + cvalue + ";" + expires + ";path=/";
    }
    quickMedalRegisterDrawer.prototype.getdrawerstatus = function(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "close";
    }
    quickMedalRegisterDrawer.prototype.setcurrenturl = function(cvalue) {
        const d = new Date();
        d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000));
        let expires = "expires="+d.toUTCString();
        document.cookie = 'quickmedalregisterdrawerurl' + "=" + cvalue + ";" + expires + ";path=/";
    }
    quickMedalRegisterDrawer.prototype.getcurrenturl = function(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "close";
    }
    quickMedalRegisterDrawer.prototype.register = function() {
        var _ = this;
        _.api.spinner.classList.add('active');
        _.label.confirmation_error.textContent = "Thank you for registering your decanter. We're verifying its authenticity to ensure exclusivity.";
        _.label.confirmation_error.classList.add('active');
        _.btn.overlay.forEach(el => {
            el.style.setProperty('pointer-events', 'none');
        });
        _.btn.close.forEach(el => {
            el.style.setProperty('pointer-events', 'none');
        });
        var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            let dataJSON = {
                "customer_email": _.input.email.value,
                "decanter_number": _.input.decanter_code.value,
                "customer_id": Number(_.input.customer_id.value),
                "rm_program": 'LXIII',
                "country": 'United Kingdom'
            }
            var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(dataJSON),
            redirect: 'follow'
            };

            const fetchData = fetch(_.api.url, requestOptions)
            .then(response => response.json())
            .then(data => {
                _.api.spinner.classList.remove('active');
                return data;
            })
            
            function handleCondition(data) {
                if (data.status === 'error') {
                    _.label.confirmation_error.textContent = data.errorMessage;
                    _.label.confirmation_error.classList.add('active');
                    _.setregistersuccess('error');
                    _.setcurrenturl('close');
                    _.btn.overlay.forEach(el => {
                        el.removeAttribute('style');
                    });
                    _.btn.close.forEach(el => {
                        el.removeAttribute('style');
                    });
                }
                if (data.status === 'success') {
                    dataLayer.push({
                        'event': 'decanter_registration'
                    });
                    _.label.confirmation_error.textContent = data.successMessage;
                    _.label.confirmation_error.classList.remove('active');
                    _.setregistersuccess('success');
                    _.setcurrenturl(window.location.pathname);
                    location.reload();
                }
            }

            fetchData.then(data => {
                const progressElement = document.getElementById('progress'),
                progressBarElement = document.querySelector('.progress-bar');

                progressElement.classList.add('doneprogress');
                    handleCondition(data);
                    setTimeout(function(){
                        progressElement.classList.remove('active');
                        progressElement.classList.remove('doneprogress');
                        progressBarElement.classList.remove('start');
    
                    },1000)

            })
            .catch(error => {
                _.label.confirmation_error.textContent = 'The server encountered an internal error or misconfiguration and was unable to complete your request. Please try again after a few minutes.';
                _.label.confirmation_error.classList.add('active');
                _.api.spinner.classList.remove('active');
                _.btn.overlay.forEach(el => {
                    el.removeAttribute('style');
                });
                _.btn.close.forEach(el => {
                    el.removeAttribute('style');
                });
                console.log('error', error);
            });
    }
    quickMedalRegisterDrawer.prototype.setregistersuccess = function(cvalue) {
        const d = new Date();
        d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000));
        let expires = "expires="+d.toUTCString();
        document.cookie = 'quickmedalregisterdrawersuccess' + "=" + cvalue + ";" + expires + ";path=/";
    }
    quickMedalRegisterDrawer.prototype.getregistersuccess = function(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "close";
    }
    quickMedalRegisterDrawer.prototype.setdecanterfirsttime = function(cvalue) {
        const d = new Date();
        d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000));
        let expires = "expires="+d.toUTCString();
        document.cookie = 'firsttimelogindecanter' + "=" + cvalue + ";" + expires + ";path=/";
    } 
    quickMedalRegisterDrawer.prototype.getdecanterfirsttime = function(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "close";
    }
    quickMedalRegisterDrawer.prototype.setuserfirsttimelogin = function(cvalue) {
        const d = new Date();
        d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000));
        let expires = "expires="+d.toUTCString();
        document.cookie = 'userfirsttimelogin' + "=" + cvalue + ";" + expires + ";path=/";
    } 
    quickMedalRegisterDrawer.prototype.getuserfirsttimelogin = function(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "on";
    }

  theme.quickMedalRegisterDrawer = new quickMedalRegisterDrawer;

}

theme.quickMedalRegisterDrawer();